import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface AssetTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AssetType {
    id?: any;
    tenantId: any;
    branchId: any;
    name:string;
    
    parameters?: AssetTypeParameter[];
    links?: any;
}

export abstract class AssetTypeData {
   
    abstract list(url: string): Observable<AssetType[]>;
    abstract create(url: string, data: AssetType): Observable<AssetType[]>;
    abstract update(url: string, data: AssetType): Observable<AssetType>;
    abstract delete(url: string): Observable<any>;
}